import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FAQsHero } from '../components/faqs/FAQsHero';
import { FAQList } from '../components/faqs/FAQList';
import { CTASection } from '../components/home/CTASection';
export function FAQsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-737">
      <Header data-id="element-738" />

      <main className="pt-20" data-id="element-739">
        <FAQsHero data-id="element-740" />
        <FAQList data-id="element-741" />
        <CTASection data-id="element-742" />
      </main>

      <Footer data-id="element-743" />
    </div>;
}